import React, { useState, useEffect } from 'react'
import Sidebar from '../sidebar'
import NavLogo from '../NavLogo'
import { MDBDataTable } from 'mdbreact'
import { ToDoFindOne, ToDoStatusUpdate } from '../../ApiFile'
import { Col, Row } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import Select from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import { toast } from 'react-toastify'
import MobileNavbarAdmin from './MobileNavbarAdmin'

const statusFlags = {
  Pending: 0,
  'Read': 1,
  'In Process': 2,
  Completed: 3,
}

const flagStatuses = {
  0: 'Pending',
  1: 'Read',
  2: 'In Process',
  3: 'Completed'
}

const ToDoAllAdmin = () => {

  const navigate = useNavigate()

  useEffect(() => {
    let flag = sessionStorage.getItem('flag')
    if (!flag) {
      navigate('/')
    }
  }, [])
  
    const [rows, setRows] = useState([])
  
     let flag = Number(sessionStorage.getItem('flag'))

    useEffect(() => {
      axios
        .get(`${ToDoFindOne}/${flag}`)
        .then((response) => {
          const mappedRows = response.data.map((row) => ({
            ...row,
            status: flagStatuses[row.status], // Map the status flag to the status text
          }))
          setRows(mappedRows)
        })
        .catch((error) => {
          console.error(error)
        })
    }, [])
  
  
    // const handleUpdateStatus = (id, newStatus) => {
    //   const flag = statusFlags[newStatus]
    //   axios
    //     .put(`${ToDoStatusUpdate}/${id}`, { status: flag })
    //     .then((response) => {
    //       if (response.data == "UPDATED") {
    //             setRows(
    //         rows.map((row) =>
    //           row.id === id ? { ...row, status: newStatus } : row,
    //         ),
    //       )
    //       toast.success('Status updated successfully')
    //       }
      
    //     })
    //     .catch((error) => {
    //       console.error(error)
    //     })
    // }
  
    // const data = {
    //   columns: [
    //     { label: 'Serial No', field: 'serial' },
    //     { label: 'Description', field: 'description' },
    //     { label: 'Completed By Date', field: 'completed_by_date' },
    //     { label: 'Created By', field: 'createdby' },
    //     { label: 'Created Date', field: 'created_date' },
    //     { label: 'Created Time', field: 'created_time' },
    //     {
    //       label: 'Status',
    //       field: 'status',
    //       sort: 'disabled',
    //       renderCell: (row) => (
    //         <Select
    //           value={row.status}
    //           onChange={(e) => handleUpdateStatus(row.id, e.target.value)}
    //           displayEmpty
    //           size="small"
    //           className="w-100"
    //           inputProps={{ 'aria-label': 'Without label' }}
    //         >
    //           {Object.entries(statusFlags).map(([key, value]) => (
    //             <MenuItem key={value} value={key}>
    //               {key}
    //             </MenuItem>
    //           ))}
    //         </Select>
    //       ),
    //     },
    //   ],
    //   rows: rows
    //   .map((row, index) => ({
    //     serial: index + 1,  
    //     ...row,
    //     status: (
    //       <Select
    //         value={row.status}
    //         onChange={(e) => handleUpdateStatus(row.id, e.target.value)}
    //         displayEmpty
    //         className="w-100"
    //         size="small"
    //         inputProps={{ 'aria-label': 'Without label' }}
    //       >
    //         <MenuItem value="">
    //           <em>Select Status</em>
    //         </MenuItem>
    //         {Object.entries(statusFlags).map(([key, value]) => (
    //           <MenuItem key={value} value={key}>
    //             {key}
    //           </MenuItem>
    //         ))}
    //       </Select>
    //     ),
    //   })),
    // }

    const handleUpdateStatus = (id, newStatus) => {
  const flag = statusFlags[newStatus]

  axios
    .put(`${ToDoStatusUpdate}/${id}`, { status: flag })
    .then((response) => {

      if (
        response.data === "UPDATED" ||
        response.data?.message === "UPDATED"
      ) {
        setRows(
          rows.map((row) =>
            row.id === id ? { ...row, status: newStatus } : row
          )
        )
        toast.success('Status updated successfully!!')
      } else {
        toast.error('Unexpected response from server')
      }
    })
    .catch((error) => {
      console.error(error)
      toast.error('Failed to update status')
    })
}


    const data = {
    columns: [
      { label: 'Serial No', field: 'serial' },
      { label: 'Description', field: 'description' },
      { label: 'Completed By Date', field: 'completed_by_date' },
      { label: 'Created By', field: 'createdby' },
      { label: 'Created Date', field: 'created_date' },
      { label: 'Created Time', field: 'created_time' },
      {
        label: 'Status',
        field: 'status',
        sort: 'disabled',
      },
    ],
    rows: rows.map((row, index) => ({
      serial: index + 1,
      ...row,
      status: (
        <Select
          value={row.status}
          onChange={(e) => handleUpdateStatus(row.id, e.target.value)}
          className="w-100"
          size="small"
        >
          {Object.entries(statusFlags).map(([key, value]) => (
            <MenuItem key={value} value={key}>
              {key}
            </MenuItem>
          ))}
        </Select>
      ),
    })),
  }



  return (
    <>
     <div className="roomchange-container" style={{ display: 'flex', minHeight: '100vh' }}>
           {/* Sidebar on the left for desktop */}
           <div className="d-none d-md-block sidebar-container" style={{ width: '270px', flexShrink: 0, }}>
             <Sidebar />
           </div>
     
           {/* Main content on the right */}
           <div className="main-content flex-grow-1" style={{ flex: 1, backgroundColor: '#f8f9fa'}}>
             <NavLogo />
             
                   <div className="d-block d-md-none">
                     <MobileNavbarAdmin />
                   </div>

        <div className="border w-100 h-100 py-3" style={{backgroundColor:"#f5f5f5ff"}}>
          <div className="row m-0 block-header ps-3">
            <h5 className="room-change-title text-start mt-md-4 mt-2" style={{ color: '#0783d6' }}>
              Task To Do
            </h5>
          </div>

        <Row
          className="m-0 p-0 px-md-3 py-1 pb-5 mb-5 mt-4 w-100"
          style={{ display: 'flex' }}
        >
          <Col
            className="m-0 p-0 px-3 py-3 rounded shadow"
            style={{ background: 'white' }}
          >
            <div style={{ overflowY: 'auto' }}>
              <div style={{ overflowX: 'auto' }}>
                <MDBDataTable
                  striped
                  className="custom-datatable text-center"
                  bordered
                  hover
                  small
                  data={data}
                />
              </div>
            </div>
          </Col>
        </Row>
      </div>
      </div>
      </div>
    </>
  )
}

export default ToDoAllAdmin
